import React, {useEffect, useState} from "react";

import {Table} from "../../common/table/Table";
import {retrieveAllTrainingGroups, retrieveTrainingGroup} from "../../../services/TrainingService";

export const TrainingGroupSearch = ({context, setContext, navigateTo, showToaster,setSpinnerText}) => {

    const [searchResults, setSearchResults] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            setSpinnerText("Retrieving Training Groups...");
            const [data, error] = await retrieveAllTrainingGroups(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    let mappedTrainingGroupList = data.trainingGroupVOList.map((trainingGroupVO) => {
                        const numberOfGroupMembers = trainingGroupVO.groupMembers.length;
                        return {...trainingGroupVO, numberOfGroupMembers}
                    });
                    setSearchResults(mappedTrainingGroupList);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    const handleRowClick = async (trainingGroup) => {
        let savedTrainingGroup = null;
        const [data, error] = await retrieveTrainingGroup(context.username, trainingGroup.externalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                savedTrainingGroup = data.trainingGroupVO;
            } else {
                showToaster(data);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }

        setContext((prevState) => ({
            ...prevState,
            selectedGroupTraining: savedTrainingGroup,
            newGroupTrainingSelected: false,
        }));

        navigateTo("trainingGroupCapture");
    }

    const handleAddButtonClick = () => {
        setContext((prevState) => ({
            ...prevState,
            selectedGroupTraining: null,
            newGroupTrainingSelected: true,
        }));
        navigateTo("trainingGroupCapture");
    }

    return (
        <div className="problem-search-results-container">
            <div className="problem-search-results-table-container">
                {searchResults &&
                <Table buttonText="New Group" onButtonClick={handleAddButtonClick} tableData={searchResults}
                       hiddenColumns={["externalReference", "groupMembers", "isDeleted", "created", "lastModified"]}
                       onRowClick={handleRowClick}
                />}
            </div>
        </div>
    );
}
